import { useAuth } from '../providers/AuthProvider';
import {
	canCreateClient,
	canCreateUser,
	canDeleteClient,
	canPerformBulkOperations,
	canPerformMaintenance,
	canUpdateClient,
	canViewAllClients,
	canViewAllSyncLogs,
	getRoleDisplayName,
	getUserDisplayName,
	isAdmin,
	isClientUser,
	isPlatformAdmin,
	isSuperAdmin,
} from '../utils/permissions';

/**
 * Custom hook for checking user permissions
 * Provides easy access to all permission checks and user info
 */
export const usePermissions = () => {
	const { user } = useAuth();

	return {
		// User info
		user,
		displayName: getUserDisplayName(user),
		roleDisplayName: user ? getRoleDisplayName(user.role) : '',

		// Role checks
		isSuperAdmin: isSuperAdmin(user),
		isPlatformAdmin: isPlatformAdmin(user),
		isClientUser: isClientUser(user),
		isAdmin: isAdmin(user),

		// Permission checks
		canCreateClient: canCreateClient(user),
		canUpdateClient: canUpdateClient(user),
		canDeleteClient: canDeleteClient(user),
		canViewAllClients: canViewAllClients(user),
		canPerformMaintenance: canPerformMaintenance(user),
		canPerformBulkOperations: canPerformBulkOperations(user),
		canCreateUser: canCreateUser(user),
		canViewAllSyncLogs: canViewAllSyncLogs(user),

		// Client info (for CLIENT_USER)
		clientId: user?.clientId || undefined,
		clientName: user?.clientName || undefined,
	};
};
